// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import Classnames from "classnames";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Css_Js_Core from "bs-css/src/Css_Js_Core.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as SearchContext$PrezzeeRibbon from "./SearchContext.bs.js";
import * as SearchBar__Icon$PrezzeeRibbon from "./SearchBar__Icon.bs.js";
import * as ReactFontawesome from "@fortawesome/react-fontawesome";
import * as ClickAwayCatcher$PrezzeeRibbon from "../ClickAwayCatcher/ClickAwayCatcher.bs.js";
import * as SearchBar__Input$PrezzeeRibbon from "./SearchBar__Input.bs.js";
import * as SearchBar__SuggestionList$PrezzeeRibbon from "./SearchBar__SuggestionList.bs.js";
import * as FaTimes from "@fortawesome/free-solid-svg-icons/faTimes";
import * as FaSearch from "@fortawesome/free-solid-svg-icons/faSearch";

var base = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.position("relative"),
      BsCssJs$PrezzeeRibbon.minHeight(BsCssJs$PrezzeeRibbon.rem(3.0)),
      BsCssJs$PrezzeeRibbon.zIndex(5000)
    ]);

var wrapper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.position("absolute"),
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100.0)),
      BsCssJs$PrezzeeRibbon.borderRadius(BsCssJs$PrezzeeRibbon.rem(1.5)),
      BsCssJs$PrezzeeRibbon.flexDirection("column"),
      BsCssJs$PrezzeeRibbon.boxShadow(Css_Js_Core.Shadow.box(BsCssJs$PrezzeeRibbon.px(4), BsCssJs$PrezzeeRibbon.px(4), BsCssJs$PrezzeeRibbon.px(25), undefined, undefined, BsCssJs$PrezzeeRibbon.rgba(0, 0, 0, BsCssJs$PrezzeeRibbon.pct(20.0))))
    ]);

var resetButton = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.alignItems("center"),
      BsCssJs$PrezzeeRibbon.position("absolute"),
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.rem(3)),
      BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.rem(3)),
      BsCssJs$PrezzeeRibbon.top("zero"),
      BsCssJs$PrezzeeRibbon.right("zero"),
      BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.rem(0.75)),
      BsCssJs$PrezzeeRibbon.boxSizing("borderBox"),
      BsCssJs$PrezzeeRibbon.selector("button", [
            BsCssJs$PrezzeeRibbon.unsafe("border", "none"),
            BsCssJs$PrezzeeRibbon.backgroundColor("transparent"),
            BsCssJs$PrezzeeRibbon.padding("zero"),
            BsCssJs$PrezzeeRibbon.outline(BsCssJs$PrezzeeRibbon.px(0), "solid", "transparent"),
            BsCssJs$PrezzeeRibbon.cursor("pointer"),
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100))
          ])
    ]);

var clearIcon = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.color(BsCssJs$PrezzeeRibbon.hex("395fa0")),
      BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(14)),
      BsCssJs$PrezzeeRibbon.boxSizing("contentBox"),
      BsCssJs$PrezzeeRibbon.paddingTop(BsCssJs$PrezzeeRibbon.px(7))
    ]);

var Styles = {
  base: base,
  wrapper: wrapper,
  resetButton: resetButton,
  clearIcon: clearIcon
};

function SearchBar(props) {
  var children = props.children;
  var className = props.className;
  var onReset = props.onReset;
  var onChange = props.onChange;
  var className$1 = className !== undefined ? className : "";
  var match = React.useState(function () {
        return false;
      });
  var setFocused = match[1];
  var listOpened = match[0] && React.Children.count(children) > 0;
  var match$1 = React.useState(function () {
        return "";
      });
  var setValue = match$1[1];
  var value = match$1[0];
  var onReset$1 = React.useCallback((function (param) {
          Curry._1(setValue, (function (param) {
                  return "";
                }));
          Curry._1(onReset, undefined);
        }), [
        onChange,
        setValue
      ]);
  var onChange$1 = React.useCallback((function (e) {
          var val = e.target.value;
          Curry._1(setValue, (function (param) {
                  return val;
                }));
          Curry._1(onChange, val);
        }), [
        onChange,
        setValue
      ]);
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(SearchBar__Icon$PrezzeeRibbon.make, {
                            children: JsxRuntime.jsx(ReactFontawesome.FontAwesomeIcon, {
                                  icon: FaSearch.faSearch
                                })
                          }),
                      JsxRuntime.jsx(SearchBar__Input$PrezzeeRibbon.make, {
                            onChange: onChange$1,
                            onEnter: props.onEnter,
                            listOpened: listOpened,
                            value: value,
                            placeholder: props.placeholder,
                            onFocus: (function (param) {
                                Curry._1(setFocused, (function (param) {
                                        return true;
                                      }));
                              })
                          }),
                      value.length > 0 ? JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("button", {
                                    children: Belt_Option.getWithDefault(props.resetIcon, JsxRuntime.jsx(ReactFontawesome.FontAwesomeIcon, {
                                              icon: FaTimes.faTimes,
                                              className: clearIcon
                                            })),
                                    onClick: onReset$1
                                  }),
                              className: resetButton
                            }) : null,
                      JsxRuntime.jsx(SearchContext$PrezzeeRibbon.Provider.make, {
                            value: value,
                            children: listOpened ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                    children: [
                                      JsxRuntime.jsx(SearchBar__SuggestionList$PrezzeeRibbon.make, {
                                            children: children
                                          }),
                                      JsxRuntime.jsx(ClickAwayCatcher$PrezzeeRibbon.make, {
                                            onClick: (function (param) {
                                                Curry._1(setFocused, (function (param) {
                                                        return false;
                                                      }));
                                              })
                                          })
                                    ]
                                  }) : null
                          })
                    ],
                    className: wrapper
                  }),
              className: Classnames([
                    base,
                    className$1
                  ])
            });
}

var Input;

var SuggestionList;

var ListItem;

var ListItemText;

var Icon;

var make = SearchBar;

export {
  Styles ,
  Input ,
  SuggestionList ,
  ListItem ,
  ListItemText ,
  Icon ,
  make ,
}
/* base Not a pure module */
